var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomCreativeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_333_30954)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2610,
    transform: "translate(-557 -591)",
    fill: "#FAFAFF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_333_30954)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -466,
    y: -277,
    width: 620,
    height: 1038,
    rx: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_333_30954)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -15,
    y: -44,
    width: 110.062,
    height: 169.379,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M83.5 42C83.5 64.9198 64.9198 83.5 42 83.5C19.0802 83.5 0.5 64.9198 0.5 42C0.5 19.0802 19.0802 0.5 42 0.5C64.9198 0.5 83.5 19.0802 83.5 42Z",
    fill: "black",
    fillOpacity: 0.1,
    stroke: "#BABCBE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6335 37.7496L57.4443 35.9388C58.7768 34.6063 58.7768 32.4367 57.4443 31.1042L55.0356 28.6954C53.7031 27.3629 51.5335 27.3629 50.201 28.6954L48.3901 30.5063L55.6335 37.7496ZM48.3901 40.1754L36.0901 52.4583H33.6814V50.0496L45.9643 37.7667L48.3901 40.1754ZM45.9643 32.915L30.2647 48.6317V55.875H37.5081L53.2076 40.1754L45.9643 32.915ZM55.8897 49.8958C55.8897 53.6371 51.5506 55.875 47.3481 55.875C46.4085 55.875 45.6397 55.1063 45.6397 54.1667C45.6397 53.2271 46.4085 52.4583 47.3481 52.4583C49.9789 52.4583 52.4731 51.2113 52.4731 49.8958C52.4731 49.0929 51.6531 48.4096 50.3718 47.8458L52.9001 45.3175C54.7281 46.3937 55.8897 47.8288 55.8897 49.8958ZM31.2556 42.8063C29.5985 41.8496 28.5564 40.6025 28.5564 38.7917C28.5564 35.7167 31.7851 34.2988 34.6381 33.0517C36.3976 32.2658 38.8064 31.2067 38.8064 30.25C38.8064 29.5496 37.4739 28.5417 35.3897 28.5417C33.2372 28.5417 32.3147 29.5837 32.2635 29.635C31.6656 30.3354 30.5893 30.4208 29.8718 29.84C29.1714 29.2592 29.0347 28.2171 29.6156 27.4825C29.8035 27.2433 31.5631 25.125 35.3897 25.125C39.2164 25.125 42.2231 27.38 42.2231 30.25C42.2231 33.4446 38.926 34.8967 36.0047 36.1779C34.3989 36.8783 31.9731 37.9375 31.9731 38.7917C31.9731 39.3213 32.7076 39.8167 33.801 40.2608L31.2556 42.8063Z",
    fill: "#79767A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_333_30954",
    x: -477,
    y: -284,
    width: 642,
    height: 1060,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_333_30954"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 3,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect2_dropShadow_333_30954"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_333_30954",
    result: "effect2_dropShadow_333_30954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_333_30954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_333_30954",
    x: -19,
    y: -47,
    width: 118.062,
    height: 177.379,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_333_30954"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_333_30954"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_333_30954",
    result: "effect2_dropShadow_333_30954"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_333_30954",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_333_30954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2610,
    fill: "white",
    transform: "translate(-557 -591)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomCreativeLogo);
export default __webpack_public_path__ + "static/media/custom-creative-logo.d673facde3d6fef82a31c4777efa7f05.svg";
export { ForwardRef as ReactComponent };